/// <reference types="@welldone-software/why-did-you-render" />
import React from 'react';
if (process.env.NODE_ENV === 'development' && process.env.NEXT_PUBLIC_WDYR) {
  if (typeof window !== 'undefined') {
    const whyDidYouRender = require('@welldone-software/why-did-you-render');
    whyDidYouRender(React, {
      trackAllPureComponents: true,
      logOnDifferentValues: true,
      trackHooks: true,
      collapseGroups: true
    });
  }
}